import template from './profile_financial.html.slim';
import controller from './profile_financial_controller';

angular.module('wbComponents').directive('profileFinancial', () => ({
  restrict: 'AE',
  controller,
  controllerAs: 'ctrl',
  bindToController: true,
  templateUrl: template,
  replace: true,

  scope: {
    clientProfile: '=',
    setDirty: '&'
  },

  link($scope, $el, $attrs) {}
}));
